import { render, staticRenderFns } from "./HomeHistoryGames.vue?vue&type=template&id=0a630006&scoped=true&"
import script from "./HomeHistoryGames.vue?vue&type=script&lang=js&"
export * from "./HomeHistoryGames.vue?vue&type=script&lang=js&"
import style0 from "./HomeHistoryGames.vue?vue&type=style&index=0&id=0a630006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a630006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a630006')) {
      api.createRecord('0a630006', component.options)
    } else {
      api.reload('0a630006', component.options)
    }
    module.hot.accept("./HomeHistoryGames.vue?vue&type=template&id=0a630006&scoped=true&", function () {
      api.rerender('0a630006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/HomeHistoryGames.vue"
export default component.exports